export default __webpack_public_path__ + "media/images/icons/icon-arrow-slider-next-7c927a5698e94467dd206d451a503969.svg";